module.exports = {"loader":{"start":"0%","progress":"%"},"incompatible":{"title":"Incompatible browser page"}}


//////////////////
// WEBPACK FOOTER
// ./src/copy/copy.json
// module id = 1102
// module chunks = 0